module.exports = __webpack_public_path__ + "img/logo-dgh.9e06b87e.png";